
import { getInfo } from '@/api/client/nice';
import { Vue, Component } from 'vue-property-decorator';
import { parseConcatNumber } from '@/utils/filters';

@Component({
  name: 'NiceAccept',
})
export default class extends Vue {
  mounted() {
    getInfo(String(this.$route.query.EncodeData)).then((res) => {
      window.opener.document.getElementById('actualName').value = res.data.name;
      window.opener.document.getElementById('concatNumber').value = parseConcatNumber(res.data.phone);
      window.close();
    });
  }
}
